// src/components/Header.jsx
import React from "react";
import "../css/admin-header.css";

const Header = () => {
    return (
        <header className="admin-header">
            <h1 className="admin-title">Admin Panel</h1>
            <div className="admin-actions">
                {/* Add buttons or profile pic here */}
                <button className="logout-button">Logout</button>
            </div>
        </header>
    );
};

export default Header;
